import { Box, Typography, useColorScheme } from "@mui/material";
import { alpha } from '@mui/material/styles';
import { Constants } from "../../utils/constants";


export default function PausedButton({ onClick = null }) {
  const { mode } = useColorScheme();
  const currentMode = mode || "light";
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: alpha(Constants.Colors[currentMode].secondary, 1),
        color: Constants.Colors[currentMode].mutedForeground,
        border: `none`,
        borderRadius: "6px",
        boxShadow: "none",
        textTransform: "none",
        cursor: onClick ? "pointer" : "unset",
        display: "inline-block",
        alignItems: "center",
        justifyContent: "center",
        padding: "1px 8px",
      }}
    >
      <Typography variant={"caption"} sx={{ fontWeight: "bold" }}>Paused</Typography>
    </Box>
  );
}
